import Chip from "@mui/material/Chip";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";

/**
 * Επιστρέφει ένα Chip με μήνυμα για τα placeholders που λείπουν.
 * @param {string[]} keys - λίστα από missing placeholders
 * @param {object} opts - προαιρετικά options
 * @param {string} opts.prefix - prefix κειμένου
 * @param {object} opts.sx - extra sx για το MDBox wrapper
 * @returns JSX.Element|null
 */
export function MissingKeysMsg(keys, opts = {}) {
  const { prefix = "Λείπουν τιμές για: ", sx } = opts;
  if (!Array.isArray(keys) || keys.length === 0) return null;

  // Αν θέλεις να φαίνονται με αγκύλες, κάνε format:
  const list = keys.map((k) => `{${k}}`).join(", ");

  return (
    <MDBox mt={0.75} sx={sx}>
      <Chip
        size="small"
        color="warning"
        icon={<Icon fontSize="small">warning</Icon>}
        label={`${prefix}${list}`}
        sx={{ fontWeight: 600 }}
      />
    </MDBox>
  );
}
